import React from 'react'
import ProfileSection from '../components/ProfileSection/ProfileSection'
import Layout from '../components/Layout/Layout'

export default function about() {
    return (
        <Layout>
            <ProfileSection/>
        </Layout>
    )
}
